import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CustomerLocationFieldRequirements } from "src/app/models/customer-address/customer-location-field-requirements";
import { CustomerService } from "src/app/services/customer/customer.service";

@Injectable()
export class CustomerLocationFieldRequirementsResolver  {
    
    constructor(private customerService: CustomerService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<CustomerLocationFieldRequirements>> {
        const response = this.customerService.getCustomerLocationFieldRequirements().pipe(map(response => { 
            if (response.success) {
                return response.payload.requirements;
            }
            else {
                return <CustomerLocationFieldRequirements> {
                    customerNumber: false,
                    addressCode: false,
                    addressName: false
                };
            }
        }));
        const responsePromise = new Promise<Observable<CustomerLocationFieldRequirements>>((resolve, reject) => { resolve( response )});
        return responsePromise;
    }
}